import _ from '@/utils/lodash-optimized'

import http from '../../../../../lib/http'
import { notify } from '../../../../../lib/Notification/actions.js'
import { map, unmap } from '../../../../../lib/Proxy/questionnaire-response.js'
import { SupportingDocumentationQuestionnaire } from '../../../../../lib/Questionnaires/index.js'
import { compartmentReceive } from '../../../patientActions.js'
import { getAssessment } from '../../lib/new-actions.js'

export const SUPPORTING_DOCUMENTATION_CATEGORY = 'Supporting Documentation'

export const GET_SUPPORTING_DOCS = 'choices/GET_SUPPORTING_DOCS'
export const GET_SUPPORTING_DOCS_SUCCESS =
  'choices/GET_SUPPORTING_DOCS_SUCCESS'
export const GET_SUPPORTING_DOCS_FAIL = 'choices/GET_SUPPORTING_DOCS_FAIL'

export const POST_SUPPORTING_DOCS = 'choices/POST_SUPPORTING_DOCS'
export const POST_SUPPORTING_DOCS_SUCCESS =
  'choices/POST_SUPPORTING_DOCS_SUCCESS'
export const POST_SUPPORTING_DOCS_FAIL = 'choices/POST_SUPPORTING_DOCS_FAIL'

export const ADD_NEW_DOC = 'ADD_NEW_DOC'
export const CLOSE_NEW_DOC = 'CLOSE_NEW_DOC'

export const typeMapping = {
  LW: 'Living Will',
  DNR: 'DNR',
  AD: 'Advanced Directive',
  PP: 'POST / POLST'
}

const makeDocsObject = formData => {
  const suffixes = [
    'Have',
    'NarusCopy',
    'Changes',
    'Copies',
    'Questions',
    'SendCopies',
    'Learning',
    'Complete'
  ]
  const prefixes = [ 'AD', 'DNR', 'LW', 'PP' ]

  const result = []
  prefixes.forEach(p => {
    if (
        suffixes.map(s => !!formData?.[`${p}${s}`])
        .indexOf(true) !== -1
    ) {
      const vals = Object.keys(formData)
        .filter(k => k.indexOf(p) !== -1)
        .map(k => ({ [k]: formData[k] }))
      const obj = vals.reduce((acc, cur) => {
        const key = Object.keys(cur)[0]
        acc[key] = cur[key]
        return acc
      }, {})
      result.push({
        type: p,
        ...obj
      })
    }
  })
  return result
}

const initializeStatus = (type, existing) => ({
  new: false,
  existing,
  type
})

export const getSupportingDocs = patientId => dispatch => {
  dispatch({ type: GET_SUPPORTING_DOCS })
  const url =
    `/patients/${patientId}/assessments?category=${SUPPORTING_DOCUMENTATION_CATEGORY}&top=1`
  return http
    .getRequest(url)
    .then(assessmentResponse => {
      const data = unmap(
          assessmentResponse?.entry?.[0]?.resource ?? {},
        SupportingDocumentationQuestionnaire
      )
      const documents = makeDocsObject(data)
      const existing = documents.map(d => d.type)
      const keys = Object.keys(typeMapping)
      const nonExistingDocs = _.difference(keys, existing)
        .map(d =>
          initializeStatus(d, false))
      const existingDocs = documents.map(d => initializeStatus(d.type,
        true))
      const docArr = existingDocs.concat(nonExistingDocs)
      const documentStats = _.keyBy(docArr,
        'type') // <------ Make array into object keyed by type
      dispatch({
        type: GET_SUPPORTING_DOCS_SUCCESS,
        documents,
        documentStats
      })
    })
    .catch(error => {
      dispatch({
        type: GET_SUPPORTING_DOCS_FAIL,
        error
      })
      dispatch(
        notify(`Error Fetching ${SUPPORTING_DOCUMENTATION_CATEGORY}`,
          true),
        true
      )
    })
}

export const createSupportingDocs =
  (formData, patientId, userId, encounterId) => dispatch => {
    dispatch({ type: POST_SUPPORTING_DOCS })
    const questionnaire = map(
      formData,
      patientId,
      userId,
      SUPPORTING_DOCUMENTATION_CATEGORY,
      encounterId,
      SupportingDocumentationQuestionnaire
    )
    return http
      .postRequest(
        `/patients/${patientId}/assessments?category=${SUPPORTING_DOCUMENTATION_CATEGORY}`,
        questionnaire
      )
      .then(assessmentResponse => {
        const data = unmap(
          assessmentResponse,
          SupportingDocumentationQuestionnaire
        )
        dispatch({
          type: POST_SUPPORTING_DOCS_SUCCESS,
          value: data,
          SUPPORTING_DOCUMENTATION_CATEGORY
        })
        dispatch(getSupportingDocs(patientId))
        dispatch(
          getAssessment(
            patientId,
            SUPPORTING_DOCUMENTATION_CATEGORY,
            SupportingDocumentationQuestionnaire
          )
        )

        dispatch(compartmentReceive(patientId))
        dispatch(
          notify(
            `Successfully Updated ${SUPPORTING_DOCUMENTATION_CATEGORY}`
          ),
          false
        )
      })
      .catch(error => {
        dispatch({
          type: POST_SUPPORTING_DOCS_FAIL,
          error
        })
        dispatch(
          notify(`Error saving ${SUPPORTING_DOCUMENTATION_CATEGORY}`, true),
          true
        )
      })
  }

export const addDocument = title => ({
  type: ADD_NEW_DOC,
  title
})

export const closeDocument = title => ({
  type: CLOSE_NEW_DOC,
  title
})
